/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1ProjectsListProjectsRequestBody = {
  /**
   * Maximum number of projects to return per request.
   *
   * @remarks
   * Balance between response size and number of pagination calls needed.
   */
  limit?: number | undefined;
  /**
   * Pagination cursor from a previous response to fetch the next page.
   *
   * @remarks
   * Use when `hasMore: true` in the previous response.
   */
  cursor?: string | undefined;
  /**
   * Free-form text to filter projects. Returns projects whose ID, name, or slug contains the search string. Matching is case-insensitive.
   */
  search?: string | undefined;
};

/** @internal */
export type V1ProjectsListProjectsRequestBody$Outbound = {
  limit: number;
  cursor?: string | undefined;
  search?: string | undefined;
};

/** @internal */
export const V1ProjectsListProjectsRequestBody$outboundSchema: z.ZodType<
  V1ProjectsListProjectsRequestBody$Outbound,
  z.ZodTypeDef,
  V1ProjectsListProjectsRequestBody
> = z.object({
  limit: z.number().int().default(100),
  cursor: z.string().optional(),
  search: z.string().optional(),
});

export function v1ProjectsListProjectsRequestBodyToJSON(
  v1ProjectsListProjectsRequestBody: V1ProjectsListProjectsRequestBody,
): string {
  return JSON.stringify(
    V1ProjectsListProjectsRequestBody$outboundSchema.parse(
      v1ProjectsListProjectsRequestBody,
    ),
  );
}
